import React, { Fragment, useEffect, useState } from 'react';
import { Col, Button, Row, FormGroup, Label, Input } from "reactstrap";
import { SelectForm, TableWithVirtualizedRow } from "../../Basicos/index";
import CardHoc from "../../Hoc/cardHoc";
import { connect } from 'react-redux';
import * as actionsRedux from '../../Store/Actions/index';
import { axiosApi } from '../../Basicos/axiosInstances';
import { AiFillFileExcel } from 'react-icons/ai';
import FileServer from 'file-saver';

function CardAgenda({
    ativar,
    subFuncionalidade: {
        url,
        tipoatividade,
        descricao
    },
}) {
    const [temaID, setTemaID] = useState();

    //Alimenta as opções
    const [periodoLetivoOptions, setPeriodoLetivoOptions] = useState();
    const [semestreOptions, setSemestreOptions] = useState();
    const [cursoOptions, setCursoOptions] = useState();
    const [temasOptions, setTemasOptions] = useState();
    const [tipoAtividadeOptions, setTipoAtividadeOptions] = useState();
    const [turmaOptions, setTurmaOptions] = useState();
    const [etapaOptions, setEtapaOptions] = useState();
    const [professorOptions, setProfessorOptions] = useState();
    const statusAula = [
        {
            "label": "Todas",
            "value": "todas"
        },
        {
            "label": "Ativa",
            "value": false
        },
        {
            "label": "Cancelada",
            "value": true
        }
    ]

    //Guarda o valor selecionado pelo usuário
    const [valorPeriodoLetivo, setValorPeriodoLetivo] = useState();
    const [valorCurso, setValorCurso] = useState();
    const [valorTema, setValorTema] = useState();
    const [valorTipoAtividade, setValorTipoAtividade] = useState([]);
    const [valorStatusAula, setValorStatusAula] = useState();
    const [semestreIds, setSemestreIds] = useState([]);
    const [dataInicio, setDataInicio] = useState();
    const [dataFim, setDataFim] = useState();
    const [valorTurma, setValorTurma] = useState();
    const [valorEtapa, setValorEtapa] = useState();
    const [valorProfessor, setValorProfessor] = useState();

    //Informações retornadas do filtro
    const [disponiveis, setDisponiveis] = useState([]);
    const [qtdHoras, setQtdHoras] = useState([]);

    const handleGrupo = (value) => {
        setSemestreIds(value);
        loadTemasOptions(value);
        getProfessoresFiltro({ semestreIds: value });
    }

    const handleAtividade = (value) => {
        setValorTipoAtividade(value)
        getProfessoresFiltro({ tipo_atividade_id: value });
    }

    const loadTemasOptions = async (semestresIds) => {
        const response = await axiosApi.get(`temas-semestre?semestresIds[]=${semestresIds}`);
        setTemasOptions(response.data.dados.map(element => ({ label: element.nome, value: element.id })))
    }

    const getProfessoresFiltro = async (filtrosNova = {}) => {
        try {
            const params = {
                semestre_id: filtrosNova.semestreIds !== undefined ? filtrosNova.semestreIds : semestreIds,
                tema_id: filtrosNova.tema_id !== undefined ? (filtrosNova.tema_id === 'selecione' ? undefined : filtrosNova.tema_id) : (valorTema?.value === 'selecione' ? undefined : valorTema?.value),
                tipo_atividade_id: filtrosNova.tipo_atividade_id !== undefined ? filtrosNova.tipo_atividade_id : valorTipoAtividade
            }
            const { data } = await axiosApi.get('/professores-filtro', { params })
            const formatOptions = (arr) => arr ? arr.map(i => ({ ...i, value: i.id || i.value, label: i.descricao || i.nome || i.nome_social || i.label || i.id })) : [];
            setProfessorOptions(formatOptions(data.professores));
        } catch (error) {
            console.log(error)
        }
    }

    const loadTiposAtividades = async (curso) => {
        const response = await axiosApi.post(curso ? `auxiliares/tipo-de-atividade/tipo-atividade-curso?${curso}` : 'auxiliares/tipo-de-atividade/tipo-atividade-curso');
        setTipoAtividadeOptions(response.data.estrutura[0].options.map(element => ({ label: element.label, value: element.value })))
    }

    const loadInfosAgenda = async () => {
        try {
            const { data } = await axiosApi.get(`semana-padrao/filtro-agenda`);
            const dados = data.dados || data.filtros || data;

            const { temas, semestre, semestres, periodo, periodosLetivos, periodos_letivos, cursos, curso, turmas, professores, tiposAtividade, tipoAtividade, tipo_atividade, status, etapas, periodoLetivoVigente, data_inicio, data_fim } = dados;

            const formatOptions = (arr) => arr ? arr.map(i => ({ ...i, value: i.id || i.value, label: i.descricao || i.nome || i.nome_social || i.label || i.id })) : [];

            const listSemestres = semestres || semestre || [];
            const listPeriodos = periodosLetivos || periodos_letivos || periodo || [];
            const listCursos = cursos || curso || [];
            const listTipoAtividade = tiposAtividade || tipoAtividade || tipo_atividade || [];

            setPeriodoLetivoOptions(formatOptions(listPeriodos));
            setSemestreOptions(listSemestres);
            setCursoOptions(formatOptions(listCursos));
            setTurmaOptions(formatOptions(turmas));
            setProfessorOptions(formatOptions(professores));
            setTipoAtividadeOptions(formatOptions(listTipoAtividade));
            setEtapaOptions(formatOptions(etapas));
            setTemasOptions(formatOptions(temas));

            const initialPeriodo = periodoLetivoVigente ? {
                value: periodoLetivoVigente.id || periodoLetivoVigente.value,
                label: periodoLetivoVigente.descricao || periodoLetivoVigente.nome || periodoLetivoVigente.label
            } : null;

            if (initialPeriodo) {
                setValorPeriodoLetivo(initialPeriodo);
            }

            if (data_inicio) setDataInicio(data_inicio);
            if (data_fim) setDataFim(data_fim);

            setValorCurso({ label: "MEDICINA", value: 17 });
            setValorTema({ value: 'selecione', label: 'Selecione' });
            setValorTipoAtividade([]);
            setValorStatusAula({ value: 'selecione', label: 'Selecione' });
            loadTiposAtividades('curso_id' + '=' + '17');

            // Dispara a busca inicial de dados.
            loadDadosAgenda({
                periodo_letivo_id: initialPeriodo?.value,
                curso_id: 17,
                data_inicio: data_inicio,
                data_fim: data_fim
            });
        } catch (error) {
            console.log('Erro ao carregar filtros da agenda:', error);
        }
    }

    const loadDadosAgenda = async (params = {}) => {
        try {
            const response = await axiosApi.post(`semana-padrao/agenda`, params);
            setDisponiveis(response.data.dados || []);
            setQtdHoras(response.data.qtdHoras || []);
        } catch (error) {
            console.log(error);
            setDisponiveis([]);
            setQtdHoras([]);
        }
    }

    const onChangeDate = (e) => {
        const { name, value } = e.target;
        if (name === 'data_inicio') setDataInicio(value);
        if (name === 'data_fim') setDataFim(value);
    };

    useEffect(() => {
        loadInfosAgenda();
    }, []);

    const onChangeSelect = (nome, valor) => {
        switch (nome) {
            case 'curso_id':
                let curso = cursoOptions.find((element) => element.value === valor);
                setValorCurso(curso)
                break;
            case 'periodo_letivo_id':
                let periodoLetivo = periodoLetivoOptions.find((element) => element.value === valor);
                setValorPeriodoLetivo(periodoLetivo)
                break;
            case 'tema_id':
                let tema = temasOptions.find((element) => element.value === valor);
                setValorTema(tema)
                setTemaID(tema.value);
                getProfessoresFiltro({ tema_id: tema.value });
                break;
            case 'status_aula':
                let status = statusAula.find((element) => element.value === valor);
                setValorStatusAula(status)
                break;
            case 'turma_id':
                let turma = turmaOptions?.find((element) => element.value === valor);
                setValorTurma(turma)
                break;
            case 'etapa_id':
                let etapa = etapaOptions?.find((element) => element.value === valor);
                setValorEtapa(etapa)
                break;
            case 'professor_id':
                let professor = professorOptions?.find((element) => element.value === valor);
                setValorProfessor(professor)
                break;
            default:
                break;
        }
    }

    const getDadosFiltrados = async () => {
        const params = {
            tipo_atividade_id: valorTipoAtividade,
            periodo_letivo_id: valorPeriodoLetivo?.value,
            semestresIds: semestreIds,
            curso_id: valorCurso?.value,
            tema_id: valorTema?.value !== 'selecione' ? valorTema?.value : undefined,
            data_inicio: dataInicio,
            data_fim: dataFim,
            status_aula: valorStatusAula?.value !== 'selecione' ? valorStatusAula?.value : undefined,
            turma_id: valorTurma?.value,
            etapa_id: valorEtapa?.value,
            professor_id: valorProfessor?.value,
        };
        await loadDadosAgenda(params);
    }

    const limparFiltro = () => {
        setValorCurso(undefined);
        setValorPeriodoLetivo(undefined);
        setSemestreIds([]);
        setDataInicio(undefined);
        setDataFim(undefined);
        setDisponiveis([]);
        setQtdHoras([]);
        setValorTema({ value: 'selecione', label: 'Selecione' });
        setValorTipoAtividade([]);
        setValorStatusAula({ value: 'selecione', label: 'Selecione' });
        setValorTurma(undefined);
        setValorEtapa(undefined);
        setValorProfessor(undefined);
        loadDadosAgenda();
    }

    const getExportDownload = async () => {
        try {
            let params = {
                tipo_atividade_id: valorTipoAtividade,
                periodo_letivo_id: valorPeriodoLetivo?.value,
                semestresIds: semestreIds,
                curso_id: valorCurso?.value,
                tema_id: valorTema?.value,
                data_inicio: dataInicio,
                data_fim: dataFim,
                status_aula: valorStatusAula?.value,
                professor_id: valorProfessor?.value,
            }
            await axiosApi.post(`exportacao/xlsx/agenda`, params, {
                responseType: 'blob',
            }).then((res) => {
                const fileName = `Agenda.xlsx`;
                const file = new File([res.data], fileName, { type: `${res?.data?.Blob?.type};charset=utf-8` });
                FileServer.saveAs(file);
            });
        } catch (error) {
            console.log(error);
        }
    }

    const semestresIdsOptions = () => semestreOptions?.map(grupo => ({ value: grupo.id || grupo.value, label: grupo.descricao || grupo.nome || grupo.label }));

    const atividadesIdsOptions = () => tipoAtividadeOptions?.map(atividade => ({ value: atividade.value, label: atividade.label }));

    const semestreIdsValue = () => semestresIdsOptions()?.filter(elemento => semestreIds?.includes(elemento.value));

    const atividadesValue = () => atividadesIdsOptions()?.filter(elemento => valorTipoAtividade?.includes(elemento.value));

    return (
        <Fragment>
            <div className="w-100" style={{ padding: '10px 0' }}>
                <div className="d-flex justify-content-between align-items-center mb-4 header-legenda text-header" style={{ padding: '0 15px' }}>
                    <h3 style={{ margin: 0, fontWeight: 'bold', color: '#1A23DF' }}>
                        <strong> {descricao} </strong>
                    </h3>
                    <div style={{ display: 'flex', gap: '15px' }}>
                        <button
                            onClick={limparFiltro}
                            style={{ backgroundColor: '#fff', color: '#1A23DF', border: '1px solid #1A23DF', borderRadius: '20px', padding: '6px 24px', fontSize: '14px', fontWeight: 'bold', cursor: 'pointer', transition: 'all 0.2s' }}
                        >
                            Limpar
                        </button>
                        <button
                            onClick={getDadosFiltrados}
                            style={{ backgroundColor: '#1A23DF', color: '#fff', border: 'none', borderRadius: '20px', padding: '6px 24px', fontSize: '14px', fontWeight: 'bold', cursor: 'pointer', transition: 'all 0.2s' }}
                        >
                            Pesquisar
                        </button>
                    </div>
                </div>

                <Row className="m-0 px-2 w-100">
                    {/* Linha 1 */}
                    <SelectForm
                        label="Curso"
                        name="curso_id"
                        placeholder="Curso"
                        options={cursoOptions}
                        onChange={onChangeSelect}
                        value={valorCurso ?? ''}
                        style={{ col: { sm: 2, xs: 2, md: 2, lg: 2, xl: 2 } }}
                    />
                    <SelectForm
                        label="Período Letivo*"
                        name="periodo_letivo_id"
                        placeholder="Período Letivo"
                        options={periodoLetivoOptions}
                        onChange={onChangeSelect}
                        value={valorPeriodoLetivo ?? ''}
                        style={{ col: { sm: 2, xs: 2, md: 2, lg: 2, xl: 2 } }}
                    />
                    <SelectForm
                        telaAgenda={true}
                        label="Semestre"
                        name="semestres_ids"
                        placeholder="Semestre"
                        value={semestreIdsValue()}
                        options={semestresIdsOptions()}
                        onChange={(input, value) => handleGrupo(value)}
                        isMulti
                        style={{ col: { sm: 2, xs: 2, md: 2, lg: 2, xl: 2 } }}
                    />
                    <SelectForm
                        label="Turma"
                        name="turma_id"
                        placeholder="Turma"
                        options={turmaOptions || []}
                        onChange={onChangeSelect}
                        value={valorTurma ?? ''}
                        style={{ col: { sm: 2, xs: 2, md: 2, lg: 2, xl: 2 } }}
                    />
                    <SelectForm
                        label="Tema"
                        name="tema_id"
                        placeholder="Tema"
                        options={temasOptions}
                        onChange={onChangeSelect}
                        readOnly={!valorTema}
                        value={valorTema ?? ''}
                        style={{ col: { sm: 2, xs: 2, md: 2, lg: 2, xl: 2 } }}
                    />
                    <SelectForm
                        label="Etapa"
                        name="etapa_id"
                        placeholder="Etapa"
                        options={etapaOptions || []}
                        onChange={onChangeSelect}
                        value={valorEtapa ?? ''}
                        style={{ col: { sm: 2, xs: 2, md: 2, lg: 2, xl: 2 } }}
                    />

                    {/* Linha 2 */}
                    <Col xs={6} md={2} sm={4} lg={2} xl={2} style={{ paddingLeft: '15px', paddingRight: '15px', marginBottom: '1rem' }}>
                        <FormGroup style={{ margin: 0 }}>
                            <Label style={{ fontSize: '13px', color: '#555', marginBottom: '5px' }}>Data Inicial*:</Label>
                            <Input type="date" name="data_inicio" value={dataInicio || ''} onChange={onChangeDate} style={{ borderRadius: '0.2rem', border: '1px solid #ced4da', fontSize: '14px', height: '38px', color: '#495057', backgroundColor: '#fff', width: '100%', padding: '0.375rem 0.75rem', outline: 'none' }} />
                        </FormGroup>
                    </Col>
                    <Col xs={6} md={2} sm={4} lg={2} xl={2} style={{ paddingLeft: '15px', paddingRight: '15px', marginBottom: '1rem' }}>
                        <FormGroup style={{ margin: 0 }}>
                            <Label style={{ fontSize: '13px', color: '#555', marginBottom: '5px' }}>Data Final*:</Label>
                            <Input type="date" name="data_fim" value={dataFim || ''} onChange={onChangeDate} style={{ borderRadius: '0.2rem', border: '1px solid #ced4da', fontSize: '14px', height: '38px', color: '#495057', backgroundColor: '#fff', width: '100%', padding: '0.375rem 0.75rem', outline: 'none' }} />
                        </FormGroup>
                    </Col>
                    <SelectForm
                        telaAgenda={true}
                        label="Tipo Atividade"
                        name="tipo_de_atividade_id"
                        placeholder="Tipo Atividade"
                        value={atividadesValue()}
                        options={atividadesIdsOptions()}
                        onChange={(input, value) => handleAtividade(value)}
                        isMulti
                        style={{ col: { sm: 2, xs: 2, md: 2, lg: 2, xl: 2 } }}
                    />
                    <SelectForm
                        label="Professor"
                        name="professor_id"
                        placeholder="Professor"
                        options={professorOptions || []}
                        onChange={onChangeSelect}
                        value={valorProfessor ?? ''}
                        style={{ col: { sm: 2, xs: 2, md: 2, lg: 2, xl: 2 } }}
                    />
                    <SelectForm
                        label="Status"
                        name="status_aula"
                        placeholder="Status"
                        options={statusAula}
                        onChange={onChangeSelect}
                        readOnly={!valorStatusAula}
                        value={valorStatusAula ?? ''}
                        style={{ col: { sm: 2, xs: 2, md: 2, lg: 2, xl: 2 } }}
                    />
                </Row>

                <div className="w-100" style={{ padding: '0 15px', marginTop: '20px', overflowX: 'auto', maxWidth: '100%' }}>
                    <TableWithVirtualizedRow
                        tabelaClassName="tabelaConsulta"
                        columns={[
                            {
                                Header: 'Data',
                                accessor: 'data_ptbr',
                                disabled: true,
                                style: { width: '110px' },
                            },
                            {
                                Header: 'Horário',
                                accessor: 'horario',
                                disabled: true,
                                style: { width: '130px' },
                            },
                            {
                                Header: 'Intervalo',
                                accessor: 'intervalo',
                                disabled: true,
                                style: { width: '130px' },
                            },
                            {
                                Header: 'Semestre',
                                accessor: 'semestre',
                                disabled: true,
                                style: { width: '90px' },
                            },
                            {
                                Header: 'Turma',
                                accessor: 'turma',
                                disabled: true,
                                style: { width: '90px' },
                            },
                            {
                                Header: 'Tema',
                                accessor: 'tema',
                                disabled: true,
                                style: { width: '170px' },
                            },
                            {
                                Header: 'Tipo',
                                accessor: 'abreviatura_tipo_atividade',
                                disabled: true,
                                style: { width: '70px' },
                            },
                            {
                                Header: 'Professor',
                                accessor: 'professor',
                                disabled: true,
                                style: { width: '200px' },
                            },
                            {
                                Header: 'Status',
                                accessor: 'status',
                                disabled: true,
                                style: { width: '100px' },
                            },
                            {
                                Header: 'Aula',
                                accessor: 'titulo',
                                disabled: true,
                                style: { width: '200px' },
                            },
                            {
                                Header: 'Local',
                                accessor: 'local',
                                disabled: true,
                                style: { width: '180px' },
                            },
                            {
                                Header: 'Grupo(s)',
                                accessor: 'grupos',
                                disabled: true,
                                style: { width: '150px' },
                            },
                            {
                                Header: 'C. H.',
                                accessor: 'duracao_aula',
                                disabled: true,
                                style: { width: '90px' },
                                Cell: ({ value }) => value ? `${value}` : ''
                            },
                        ]}
                        data={disponiveis}
                    />

                    {/* Rodapé com totais */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '12px 15px',
                        marginTop: '10px',
                        borderTop: '1px solid #dee2e6'
                    }}>
                        <div style={{ display: 'flex', gap: '20px', fontSize: '14px', color: '#333' }}>
                            <span><strong>Total</strong></span>
                            <span>Aulas: <strong>{disponiveis.length}</strong></span>
                            {qtdHoras?.map((modulo, index) => (
                                <span key={index}>C.H. {modulo.modulo_nome}: <strong>{modulo.total_horas}</strong></span>
                            ))}
                        </div>
                        {
                            disponiveis.length > 0 ?
                                <Button
                                    className="float-right export-btnConsulta"
                                    size="sm"
                                    onClick={() => getExportDownload()}
                                >
                                    <AiFillFileExcel size="1.2rem" style={{ padding: '1px' }} />
                                    Exportar XLSX
                                </Button>
                                : ""
                        }
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        atualizarDadosRemotamente: (params) => dispatch(actionsRedux.atualizarSubFuncionalidade(ownProps.funcionalidade, ownProps.indiceSubFuncionalidade, params)),
        ativar: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao)),
    }
}

const mapStateToProps = (state) => {
    return {
        estruturaModal: state.subFuncionalidades.estruturaModal,
        estadoModal: state.subFuncionalidades.estadoModal,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CardHoc(CardAgenda))